const isEmptyValidation = (value) => value.length > 0;
const emailValidation = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
const mobilePhoneNumberValidation = (value) => /^(07\d)(\d{7})$/.test(value);

export const Validate = (elm, type) => {
	let value = elm.value;
	let isError = false;

	switch (type) {
		case "password":
			isError = !isEmptyValidation(value);
			break;
		case "email":
			isError = !emailValidation(value);
			break;
		case "phoneNumber":
			value = value.replace("-", "");
			isError = !mobilePhoneNumberValidation(value);
			break;
		default:
			break;
	}

	return isError;
};
